import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface CustomerManager {
    customer_manager_idx: number;
    manager_email: string;
    manager_name: string;
    manager_mobile: string;
}

interface GetCustomerResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: CustomerManager[];
}

export const useGetCustomerManager = (customerId: number, page: number, searchtxt?: string): UseQueryResult<GetCustomerResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetCustomerResponse, Error>({
        queryKey: ["getCustomerManager", customerId, page, searchtxt],
        queryFn: async () => {
            const response = await axios.get(
                `${enum_api_uri.get_customer_manager.replace(":customer_idx", customerId.toString())}?page=${page}&limit=5&search=manager_name&searchtxt=${searchtxt}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                    current_page: page,
                };
            }
            return undefined;
        },
    });
};
